import type { OfflineProductSearchParams } from '../types';

export const offlineOrderKeys = {
  all: ['offline-orders'] as const,
  cart: () => [...offlineOrderKeys.all, 'cart'] as const,
  search: (params: OfflineProductSearchParams) =>
    [...offlineOrderKeys.all, 'search', params] as const,
  coupons: (phoneNumber: string, cartValue: number) =>
    [...offlineOrderKeys.all, 'coupons', phoneNumber, cartValue] as const,
};
